export type CameraReportReasonId =
  | 'camera-obstruction'
  | 'poor-lighting'
  | 'generating-false-alarm';

export interface CameraReportReasonOption {
  readonly id: CameraReportReasonId;
  readonly label: string;
  readonly iconSrc: string;
}

export const CAMERA_REPORT_REASON_OPTIONS: readonly CameraReportReasonOption[] = [
  {
    id: 'camera-obstruction',
    label: 'Camera\nObstruction',
    iconSrc: '/assets/events/icons/report/camera-obstruction.svg',
  },
  {
    id: 'poor-lighting',
    label: 'Poor\nLighting',
    iconSrc: '/assets/events/icons/report/poor-lighting.svg',
  },
  {
    id: 'generating-false-alarm',
    label: 'Generating\nFalse Alarm',
    iconSrc: '/assets/events/icons/report/generating-false-alarm.svg',
  },
] as const;

export interface CameraReportConfirm {
  readonly reasonId: CameraReportReasonId;
}
